/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimOrganization
 */
export interface ClaimOrganization {
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganization
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganization
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganization
     */
    claimId: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganization
     */
    organizationId: number;
    /**
     * Free-form role (e.g. insurer, contractor, public_adjuster_firm)
     * @type {string}
     * @memberof ClaimOrganization
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimOrganization
     */
    notes?: string | null;
    /**
     * Enriched insured name from joined claim table
     * @type {string}
     * @memberof ClaimOrganization
     */
    insuredName?: string;
    /**
     * Enriched claim number from joined claim table
     * @type {string}
     * @memberof ClaimOrganization
     */
    claimNumber?: string;
    /**
     * Enriched organization name from joined organization table
     * @type {string}
     * @memberof ClaimOrganization
     */
    organizationName?: string;
    /**
     * Enriched organization email from joined organization table
     * @type {string}
     * @memberof ClaimOrganization
     */
    organizationEmail?: string | null;
    /**
     * Enriched organization type from joined organization table
     * @type {string}
     * @memberof ClaimOrganization
     */
    orgType?: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimOrganization
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ClaimOrganization interface.
 */
export function instanceOfClaimOrganization(value: object): value is ClaimOrganization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ClaimOrganizationFromJSON(json: any): ClaimOrganization {
    return ClaimOrganizationFromJSONTyped(json, false);
}

export function ClaimOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'claimId': json['claimId'],
        'organizationId': json['organizationId'],
        'role': json['role'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'insuredName': json['insuredName'] == null ? undefined : json['insuredName'],
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'organizationEmail': json['organizationEmail'] == null ? undefined : json['organizationEmail'],
        'orgType': json['orgType'] == null ? undefined : json['orgType'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ClaimOrganizationToJSON(json: any): ClaimOrganization {
    return ClaimOrganizationToJSONTyped(json, false);
}

export function ClaimOrganizationToJSONTyped(value?: ClaimOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'organizationId': value['organizationId'],
        'role': value['role'],
        'notes': value['notes'],
        'insuredName': value['insuredName'],
        'claimNumber': value['claimNumber'],
        'organizationName': value['organizationName'],
        'organizationEmail': value['organizationEmail'],
        'orgType': value['orgType'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

